// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, schema de busca, catálogo e o carregador
// da tela. Outro módulo usa a `public.ts` (A06).
export { PIX_MED_PATH, pixMedAdminScreen } from './pix-med.screen';
export { pixMedSearch } from './pix-med.search';
export { loadPixMedMessages } from './pix-med.catalog';

/** A tela da rota (`PixMedAdminRouteScreen`), por `lazyScreen`. */
export const loadPixMedScreens = () => import('./pix-med.page');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadPixMedGuides = () => import('./pix-med.guide');
